import { Directive, Input, ElementRef, Renderer2, OnInit, OnDestroy, TemplateRef, ViewContainerRef, } from '@angular/core';
import { PlanAccessService } from './../_services/plan-access.service';
import { RestrictedContentComponent } from './../_components/restricted-content/restricted-content.component';
import { NotificationService } from './../../shared/_components/shared-notification/notification.service';
import { Subscription } from 'rxjs';
import { AuthService } from './../_services/auth.service';

@Directive({
  selector: '[appRestrictByFeature]',
})

export class RestrictByFeatureDirective implements OnInit, OnDestroy {
  @Input('appRestrictByFeature') feature!: string;
  @Input() appRestrictedTemplate?: TemplateRef<any>;
  @Input() appRestrictByStateSlug?: string;

  private overlay: HTMLElement | null = null;
  private blurWrapper: HTMLElement | null = null;
  private planSubscription!: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private planAccess: PlanAccessService,
    private viewContainerRef: ViewContainerRef,
    private notificationService: NotificationService, private authService: AuthService
  ) { }

  async ngOnInit() {
    this.preBlur();
    this.planSubscription = this.planAccess.userPlan$.subscribe(plan => {
      this.updateAccess();
    });
  }

  private updateAccess(): void {
    let hasFeatureAccess = this.planAccess.hasAccess(this.feature as any);
    const userPlan = this.planAccess.getUserPackage();

    if (this.feature === 'pdpTenderOverview' && userPlan === 'basic' && this.appRestrictByStateSlug) {
      const hasStateAccess = this.planAccess.hasAccessToState(this.appRestrictByStateSlug);
      hasFeatureAccess = hasStateAccess;
    }

    if (!hasFeatureAccess) {
      this.showRestriction();
    } else {
      this.removePreBlur();
      if (this.overlay) {
        this.renderer.removeChild(this.el.nativeElement, this.overlay);
        this.overlay = null;
      }
    }
  }

  ngOnDestroy() {
    if (this.planSubscription) {
      this.planSubscription.unsubscribe();
    }
    if (this.overlay) {
      this.renderer.removeChild(this.el.nativeElement, this.overlay);
    }
    if (this.blurWrapper) {
      while (this.blurWrapper.firstChild) {
        this.renderer.appendChild(this.el.nativeElement, this.blurWrapper.firstChild);
      }
      this.renderer.removeChild(this.el.nativeElement, this.blurWrapper);
    }
  }

  private preBlur() {
    const host = this.el.nativeElement;
    this.blurWrapper = this.renderer.createElement('div');
    this.renderer.setStyle(this.blurWrapper, 'transition', 'filter 0.3s ease');
    this.renderer.setStyle(this.blurWrapper, 'filter', 'blur(4px)');
    this.renderer.setStyle(this.blurWrapper, 'pointer-events', 'none');

    while (host.firstChild) {
      this.renderer.appendChild(this.blurWrapper, host.firstChild);
    }
    this.renderer.appendChild(host, this.blurWrapper);
    this.renderer.setStyle(host, 'position', 'relative');
  }

  private removePreBlur() {
    if (!this.blurWrapper) return;
    const host = this.el.nativeElement;
    while (this.blurWrapper.firstChild) {
      this.renderer.appendChild(host, this.blurWrapper.firstChild);
    }
    this.renderer.removeChild(host, this.blurWrapper);
    this.blurWrapper = null;
  }

  private async showRestriction() {
    const host = this.el.nativeElement;

    const overlay = this.renderer.createElement('div');
    this.overlay = overlay;
    this.renderer.setStyle(overlay, 'position', 'absolute');
    this.renderer.setStyle(overlay, 'top', '0');
    this.renderer.setStyle(overlay, 'left', '0');
    this.renderer.setStyle(overlay, 'width', '100%');
    this.renderer.setStyle(overlay, 'height', '100%');

    this.renderer.setStyle(overlay, 'display', 'flex');
    this.renderer.setStyle(overlay, 'align-items', 'center');
    this.renderer.setStyle(overlay, 'justify-content', 'center');

    if (this.appRestrictedTemplate) {
      const embeddedView = this.viewContainerRef.createEmbeddedView(this.appRestrictedTemplate);
      embeddedView.rootNodes.forEach(node => this.renderer.appendChild(overlay, node));
    } else {
      const componentFactory = this.viewContainerRef.createComponent(RestrictedContentComponent);
      this.renderer.appendChild(overlay, componentFactory.location.nativeElement);
    }

    this.renderer.appendChild(host, overlay);

    if (this.feature === 'pdpTenderOverview') {
      const { plan, daysLeft } = await this.authService.getPlanAndDaysLeft();
      this.notificationService.showPlanAndTrialMessage(plan as any, daysLeft);
    }
  }
}

